import React, { memo, useCallback, useEffect, useRef, useState, HTMLAttributes } from "react";

import "./CustomSelect.css";

export type SimpleSelectPropsType = {
  value: string;
  defaultValue?: string;
  label: string;
  dropdownData: Array<string>;
  validate?: boolean;
  onChange: (item: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  onBlur?: () => void;
}

type CombinedPropsType = SimpleSelectPropsType & HTMLAttributes<HTMLDivElement>;

const SimpleSelect = (props: CombinedPropsType) => {
  const {
    value,
    defaultValue,
    label,
    dropdownData,
    validate = false,
    onChange,
    placeholder,
    disabled,
    required,
    onBlur
  } = props;
  const [isOpen, toggleOpen] = useState(false);
  const getErrorStatus = () => {
    return !value;
  };
  const error = validate ? getErrorStatus() : false;
  const inputRef: any = useRef(null);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (!inputRef.current.contains(event.target)) {
      toggleOpen(false);
      document.removeEventListener("mousedown", handleClickOutside);
      if (onBlur) {
        onBlur();
      }
    }
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen, handleClickOutside]);

  const handleCheckboxChange = (item: string) => {
    const checked = value === item;
    if (!checked) {
      onChange(item);
    } else {
      onChange("");
    }
    toggleOpen(false);
    document.removeEventListener("mousedown", handleClickOutside);
  };

  const handleDropdownClick = () => toggleOpen(!isOpen);

  //to display selected items on select box
  const getSelectedItems = () => {
    if (defaultValue && !value) return defaultValue;
    if (value) {
      return value?.length > 30 ? value.slice(0, 30) + "..." : value;
    }
    return "";
  };

  const getDropdownPosition = (): string => {
    return window.innerHeight / 2 < inputRef.current.getBoundingClientRect().top
      ? "checkbox-dropdown ms-upward"
      : "checkbox-dropdown";
  };
  const getDropdownHeight = (): number => {
    let height = 0;
    if (window.innerHeight / 2 < inputRef.current.getBoundingClientRect().top)
      height = inputRef.current.getBoundingClientRect().top - 60;
    else
      height =
        window.innerHeight -
        inputRef.current.getBoundingClientRect().top -
        inputRef.current.getBoundingClientRect().height -
        10;
    return height > 385 ? 385 : height;
  };
  const getSelectedStyle = (item: string) => {
    return value === item ? "selected" : "";
  };
  const renderCheckboxList = () =>
    dropdownData.map((item: string, index: number) => (
      <div
        key={index}
        className={
          `flex space-between co-cpf-checkbox mt-0 ms-checkbox-item ${!disabled && "curson-pointer align-center"}` +
          getSelectedStyle(item)
        }
        onClick={() => handleCheckboxChange(item)}
      >
        <span className="fs-14 w-250">{item}</span>
        <i />
      </div>
    ));

  const selectedValue = getSelectedItems();

  return (
    <div className="MuiFormControl-root w-full custom-select" ref={inputRef}>
      {selectedValue && label && (
        <div className={`cs-float-lbl ${isOpen && "cs-float-lbl-selected"}`}>
          {`${label}${required ? '*' : ''}`}
        </div>
      )}
      {!selectedValue && (
        <label
          className={`MuiFormLabel-root MuiInputLabel-formControl MuiInputLabel-outlined ${error && "Mui-error"
            }`}
        >
          {`${label}${required ? '*' : ''}`}
        </label>
      )}
      <div className="relative">
        <div
          className={`MuiOutlinedInput-input ms-border ${!disabled && "cursor-pointer"} ${error && "ms-border-error"
            } ${isOpen && "ms-border-selected"}`}
          onClick={disabled ? () => { } : handleDropdownClick}
        >
          <input
            type="text"
            placeholder={placeholder || ""}
            readOnly
            className="checbox-input ellipsis"
            value={selectedValue || ""}
            disabled={disabled}
          />
          <img
            //up and down motion of the arrow
            alt=""
            className={
              isOpen ? "ms-dropdown-arrow ms-arrow-rotate" : "ms-dropdown-arrow"
            }
            src="/self-serve/ic_dropdown@3x.png"
            height={7}
            width={11}
          />
        </div>
        {isOpen && (
          <div className={getDropdownPosition()}>
            <div>
              <div
                className="ms-checkbox-wrapper"
                style={{ maxHeight: getDropdownHeight() }}
              >
                {renderCheckboxList()}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(SimpleSelect);
